<div fxLayout="column">
    <div *ngIf="!isLoading" fxLayout="row" fxFlex="grow" fxLayoutAlign="center center center"
         style="height: 100px;border-bottom:1px solid lightgray;">

        <div fxFlex="5">&nbsp;</div>

        <div fxFlex="30" style="font-family: 'Century Gothic', sans-serif" fxLayoutAlign="start center center">Τίτλος</div>
        <div fxFlex="15" style="font-family: 'Century Gothic', sans-serif" fxLayoutAlign="start center center">
            Περιγραφή
        </div>
        <div fxFlex="22" style="font-family: 'Century Gothic', sans-serif" fxLayoutAlign="center center center">Διαβάστηκαν
        </div>
        <div fxFlex="22" style="font-family: 'Century Gothic', sans-serif" fxLayoutAlign="center center center">Σε αναμονή
        </div>
        <div fxFlex="5"></div>
    </div>

    <div fxLayout="row wrap" fxLayoutAlign="center center center">
        <div fxLayoutAlign="center center center"
             style="height: 100px;border-bottom:1px solid lightgray;" fxFlex="100"
             *ngFor="let reportAnnouncement of announcements">

            <div fxFlex="5">
                <mat-icon>bookmark</mat-icon>
            </div>

            <div fxFlex="30" style="font-family: 'Century Gothic', sans-serif"
                 fxLayoutAlign="start center center">{{reportAnnouncement.title}}</div>
            <div fxFlex="15" style="font-family: 'Century Gothic', sans-serif"
                 fxLayoutAlign="start center center">{{reportAnnouncement.description}}</div>
            <div fxLayout="column" fxFlex="22">
                <div fxLayout="row"
                     fxLayoutAlign="center center center">{{calculateOpened(reportAnnouncement.unique_id)}}</div>
                <div fxLayout="row" fxLayoutAlign="center center center">
                    <mat-icon [ngStyle]="{'color': 'green'}">stop</mat-icon>&nbsp;Διαβάστηκαν
                </div>
            </div>

            <div fxLayout="column" fxFlex="22">
                <div fxLayout="row" fxLayoutAlign="center center center">{{calculatePending(reportAnnouncement.unique_id)}}</div>
                <div fxLayout="row" fxLayoutAlign="center center center">
                    <mat-icon [ngStyle]="{'color': 'orange'}">stop</mat-icon>&nbsp;Σε αναμονή
                </div>
            </div>


            <div fxLayout="column" fxFlex="5">
<!--                <div #menuTrigger="matMenuTrigger" [matMenuTriggerFor]="menu" style="cursor: pointer;">-->
<!--                    <div fxLayout="row" fxLayoutAlign="center center center" fxShow.gt-sm fxHide.lt-md>-->
<!--                        &lt;!&ndash;                  <label style="cursor: pointer;">Ενέργεια</label>&ndash;&gt;-->
<!--                        <button mat-flat-button [ngStyle]="{'background': 'transparent', 'color':'black'}"-->
<!--                                style="font-family: 'Century Gothic', sans-serif !important;">-->
<!--                            <mat-icon style="vertical-align: middle; color:var(&#45;&#45;haeforangePrimary);">-->
<!--                                {{menuTrigger.menuOpen ? 'expand_less' : 'expand_more'}}-->
<!--                            </mat-icon>-->
<!--                        </button>-->

<!--                    </div>-->

<!--                    <div fxLayout="row" fxLayoutAlign="center center center" fxHide.gt-sm fxShow.lt-md>-->

<!--                        <button mat-icon-button>-->
<!--                            <mat-icon style="vertical-align: middle;">-->
<!--                                more_vert-->
<!--                            </mat-icon>-->
<!--                        </button>-->

<!--                    </div>-->
<!--                </div>-->

<!--                <mat-menu #menu="matMenu">-->
<!--                    <mat-list>-->
<!--                        <mat-list-item class="menuList" >-->
<!--                            <button mat-menu-item (click)="navigateToDetails(reportAnnouncement)">-->
<!--                                <mat-icon class="icon">visibility</mat-icon>&nbsp;Προβολή λεπτομερειών-->
<!--                            </button>-->
<!--                        </mat-list-item>-->
<!--                        <mat-list-item class="menuList">-->
<!--                            <button mat-menu-item (click)="notifyUsers(reportAnnouncement)">-->
<!--                                <mat-icon class="icon">send</mat-icon>&nbsp;Αποστολή ενημέρωσης-->
<!--                            </button>-->
<!--                        </mat-list-item>-->
<!--                    </mat-list>-->
<!--                </mat-menu>-->
            </div>
        </div>

        <div *ngIf="isLoading" fxFlex fxLayoutAlign="center center center" style="margin-top:50px; !important;">
            <app-loading></app-loading>
        </div>

        <div *ngIf="announcements.length === 0 && !isLoading">
            <div style="margin-top: 50px; margin-bottom: 50px; font-family: 'Century Gothic', sans-serif;">
                Δεν υπάρχουν αναφορές για ανακοινώσεις
            </div>
        </div>
    </div>
</div>
